import { useEffect, useState } from 'react';
import axios from '../helpers/axios'

export const createNewCategory = async (values, callback) => {
    const res = await axios.post(`/category/createcategory`, values);
    if (res.status === 200) {
        callback(res.data.response);
    } else {
        callback(res.data.response)
    }
}

export const updateCategory = async (id, values, callback) => {
    const res = await axios.put(`/category/updatecategory/${id}`, values);

    if (res.status === 200) {
        callback(res.data.response);
    } else {
        callback(res.data.response);
    }
}

export const deleteCategory = async (id, value, callback) => {
    const res = await axios.put(`/category/deletecategory/${id}`, { updatedBy: value });

    if (res.status === 200) {
        callback(res.data.response);
    } else {
        callback(res.data.response);
    }
}

export const getAllCategories = async (rowPerPage, pageNumber, search, callback) => {
    const res = await axios.get(`/category/?rowPerPage=${rowPerPage}&pageNumber=${pageNumber}&search=${search}`);
    if (res.status === 200) {
        const categoryList = res.data.response.data;
        callback(categoryList)
    } else {
        callback(res.data.response);
    }
}

export const getCategories = async (callback) => {
    const res = await axios.get(`/category/getall`);

    if (res.status === 200) {
        const categoryList = res.data.data;
        callback(categoryList)
    } else {
        callback(res.data.response);
    }
}

export const getCategoryById = async (id, callback) => {
    axios.get(`/category/${id}`).then(res => {

        if (res.status === 200) {
            callback(res.data.response.data);
        } else {
            callback(res.data.response.data)
        }
    })

}


export const CategoryAPI = () => {
    const [categories, setCategories] = useState([]);
    const [allCategories, setAllCategories] = useState([])
    const [categoryDetail, setCategoryDetail] = useState({});

    const [rowPerPage, setRowPerPage] = useState(10);
    const [search, setSearch] = useState("");
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [callback, setCallback] = useState(false);
    const [id, setId] = useState(0);

    useEffect(() => {
        getAllCategories(rowPerPage, pageNumber, search, res => {
            setCategories(res);
            setTotalPages(res.totalPage || 1)
        })

        getCategories(res => {
            setAllCategories(res)
        })

        getCategoryById(id, res => {
            setCategoryDetail(res);
        })

    }, [callback, rowPerPage, search, pageNumber, id])

    return {
        categories: [categories, setCategories],
        allCategories: [allCategories, setAllCategories],
        categoryDetail: [categoryDetail, setCategoryDetail],
        id: [id, setId],
        rowPerPage: [rowPerPage, setRowPerPage],
        search: [setSearch],
        pageNumber: [pageNumber, setPageNumber],
        totalPages: [totalPages, setTotalPages],
        callback: [callback, setCallback]
    }
}
